export default {"src":"/_next/static/media/SubDesc5.4edf4d96.svg","height":121,"width":120,"blurWidth":0,"blurHeight":0};